/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useEffect } from 'react'
import { withTranslation } from 'react-i18next'
import styles from './CasesList.module.scss'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useDispatch } from 'react-redux'
import { amountOwingAction, editCaseNumberAction, paymentAmountFullAction, deleteCaseAction } from 'redux/actions'

const CasesList = ({ t, i18n, setIsError }) => {
  let history = useHistory()
  const dispatch = useDispatch()

  const cases = useSelector((state) => state.app.cases)

  useEffect(() => {
    try {
      if (cases.length === 0) {
        history.push(`/${i18n.language}${t('routes.case_info')}`)
      }
      cases.map((caseInfo) => {
        if (caseInfo && caseInfo.amountOwing === '' && caseInfo.paymentAmount === '') {
          dispatch(deleteCaseAction(caseInfo.caseNumber))
        }
      })
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }, [cases])

  const getCaseOwingSum = (type) => {
    try {
      return cases
        .filter((obj, index, self) => index === self.findIndex((o) => o.caseNumber === obj.caseNumber))
        .reduce(function (a, b) {
          return a + parseFloat(b[type])
        }, 0)
    } catch (e) {
      console.log(e)
    }
  }

  const getPaymentAmountSum = (type) => {
    try {
      return cases.reduce(function (a, b) {
        return a + parseFloat(b[type])
      }, 0)
    } catch (e) {
      console.log(e)
    }
  }

  const getBalanceRemainingSum = () => {
    try {
      return getCaseOwingSum('amountOwing') - getPaymentAmountSum('paymentAmount')
    } catch (e) {
      console.log(e)
    }
  }

  const getAmountString = (num, main) => {
    try {
      if (main) {
        return i18n.language === 'en' ? (
          <td>
            <strong>$</strong> {`${num}`}
          </td>
        ) : (
          <td>
            {`${num.toString().replace('.', ',')}`} <strong>$</strong>
          </td>
        )
      }
      return i18n.language === 'en' ? `$ ${num}` : `${num.toString().replace('.', ',')} $`
    } catch (e) {
      console.log(e)
    }
  }

  // const removeZerosAfterDecimal = (num) => {
  //   try {
  //     return (num.substring(num.length - 3) === '.00' || num.substring(num.length - 3) === ',00') ? num.substring(0, num.length - 3) : num
  //   }
  //   catch (err) {
  //     console.log(err)
  //   }
  // }

  return (
    <div className="row">
      <div className="col-xs-12 col-md-8">
        <div className={styles['overflow_mobile']}>
          <table className={['table table-bordered', styles['cases_table']].join(' ')}>
            <thead>
              <tr>
                <th>{t('cases_list.case_number')}</th>
                <th>{t('cases_list.amount_owing')}</th>
                <th>{t('cases_list.payment_amount')}</th>
                <th>{t('cases_list.balance')}</th>
                <th>{t('cases_list.action')}</th>
              </tr>
            </thead>
            <tbody>
              {cases.map((caseInfo, i) => {
                return (
                  <CasesRow
                    key={i}
                    caseInfo={caseInfo}
                    t={t}
                    i18n={i18n}
                    setIsError={setIsError}
                    getAmountString={getAmountString}
                    remaingBalance={caseInfo.amountOwing - caseInfo.paymentAmount}
                  />
                )
              })}
              <tr>
                <td>
                  <strong>{t('cases_list.total')}</strong>
                </td>
                <td data-label={t('cases_list.amount_owing')}>{getAmountString(getCaseOwingSum('amountOwing').toFixed(2), true)}</td>
                <td data-label={t('cases_list.payment_amount')}>
                  {getAmountString(getPaymentAmountSum('paymentAmount').toFixed(2), true)}
                </td>
                <td data-label={t('cases_list.balance')}>{getAmountString(getBalanceRemainingSum().toFixed(2), true)}</td>
                <td className={styles['display_none']}></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

const CasesRow = ({ caseInfo, i18n, t, setIsError, getAmountString, remaingBalance }) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const cases = useSelector((state) => state.app.cases)

  const getCaseData = (caseNumber) => {
    let caseData = cases.filter((caseInfo) => caseInfo.caseNumber === caseNumber)
    if (caseData.length > 0) {
      return caseData[0]
    }
    return false
  }

  const editCaseOnClick = () => {
    try {
      dispatch(editCaseNumberAction(caseInfo.caseNumber))
      let caseData = getCaseData(caseInfo.caseNumber)
      if (caseData) {
        dispatch(paymentAmountFullAction(''))
        dispatch(amountOwingAction(caseData['amountOwing']))
      }
      history.push(`/${i18n.language}${t('routes.case_owing_info')}`)
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const removeCaseOnClick = (caseNumber) => {
    try {
      dispatch(deleteCaseAction(caseNumber))
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const popUpBox = (caseNumber) => {
    let confirmText = window.confirm(`${t('cases_list.are_you_sure')}`)
    if (confirmText == true) {
      removeCaseOnClick(caseNumber)
    }
  }

  return (
    <tr>
      <td data-label={t('cases_list.case_number')}>{caseInfo.caseNumber}</td>
      <td data-label={t('cases_list.amount_owing')}>{getAmountString(parseFloat(caseInfo.amountOwing).toFixed(2))}</td>
      <td data-label={t('cases_list.payment_amount')}>{getAmountString(parseFloat(caseInfo.paymentAmount).toFixed(2))}</td>
      <td data-label={t('cases_list.balance')}>{getAmountString(parseFloat(caseInfo.amountOwing - caseInfo.paymentAmount).toFixed(2))}</td>
      <td>
        <div style={{ display: 'flex' }}>
          {caseInfo.paymentAmountFull !== 'final' && (
            <button
              className={['btn-xs btn-default', styles['edit_button']].join(' ')}
              onClick={editCaseOnClick}
              value={t('cases_list.edit')}
              name={t('cases_list.edit')}
            >
              {t('cases_list.edit')}
            </button>
          )}
          <a
            href={`/${i18n.language}${t('routes.review_confirmation')}`}
            className={styles['remove_button']}
            onClick={() => popUpBox(caseInfo.caseNumber)}
            value={t('cases_list.remove')}
            name={t('cases_list.remove')}
          >
            {t('cases_list.remove')}
          </a>
        </div>
      </td>
    </tr>
  )
}

export default withTranslation('common')(CasesList)
